// Client-side mirror of the server env/country definitions. Kept tiny and
// separate because the SPA and Functions are different build roots.

export type Environment = 'DEVELOP' | 'STAGING'
export type CountryCode = 'KE' | 'GH' | 'NG' | 'UG' | 'ZA'

export const ENVIRONMENTS: { value: Environment; label: string }[] = [
  { value: 'DEVELOP', label: 'Develop' },
  { value: 'STAGING', label: 'Staging' },
]

export const COUNTRIES: { value: CountryCode; label: string }[] = [
  { value: 'KE', label: 'Kenya (KE)' },
  { value: 'GH', label: 'Ghana (GH)' },
  { value: 'NG', label: 'Nigeria (NG)' },
  { value: 'UG', label: 'Uganda (UG)' },
  { value: 'ZA', label: 'South Africa (ZA)' },
]
